// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { observable, action, makeObservable } from 'mobx';
import { injectable } from 'inversify';

import container from '@core/di';

import DashboardService from '@shared/services/dashboard';
import OrderSummary from '@shared/models/dashboard/order-summary';
import AssetSummary from '@shared/models/dashboard/asset-summary';
import { ListRequestParams } from '@shared/types/services';

@injectable()
export default class DashboardStore {
  static diToken = Symbol('dashboard-store');
  private service = container.get<DashboardService>(DashboardService.diToken);
  @observable orderSummary: OrderSummary;
  @observable assetSummary: AssetSummary;

  constructor() {
    makeObservable(this);
  }

  @action getOrderSummary = async (params: ListRequestParams) => {
    try {
      const orderSummary = await this.service.getOrderSummary(params);
      this.orderSummary = orderSummary;

      return orderSummary;
    } catch (err) {
      throw err;
    }
  }

  @action getAssetSummary = async (params: ListRequestParams) => {
    try {
      const assetSummary = await this.service.getAssetSummary(params);
      this.assetSummary = assetSummary;

      return assetSummary;
    } catch (err) {
      throw err;
    }
  }

}